// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { _BaseGeneralSettingsUtils } from '@shared/commons/UtilsClasses/BaseGeneralSettingsUtils';
import { BaseGeneralSettingsUtilsInstanceCreator } from '@shared/commons/UtilsClasses/BaseGeneralSettingsUtilsWrapper';
export class WDGeneralSettingsUtils extends _BaseGeneralSettingsUtils {
}
export const WDSettingsUtils = new WDGeneralSettingsUtils();
BaseGeneralSettingsUtilsInstanceCreator(WDSettingsUtils);
